import React, { useState, useEffect } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { navigate } from 'gatsby';
import grid from "../../scss/flexboxgrid.module.scss"
import view from "./searchbar.module.scss"

import DropdownOption from "./Dropdown"

const staticQuery = (graphql`
  query {
    LunrIndex
    allInventoryJson {
      nodes {
        VehicleInfo {
          IsCertified
          IsNew
          Model
          Make
          BodyType
          VehicleStatus
          Year
          VIN
          DealerID
          DealerName
        }
        Banner {
          BannerContent {
          bgColor
          placement
          text
          textColor
          }
        }
      }
    }
  }
`)

export default function SearchBar({ data, mainDealerID, passedProp }) {
  const dealerID = mainDealerID
  let dealerNameNoSpace = "";
  const labelMap = {
    certified: { Certified: true },
    new: { New: true, 'Used & Certified': false, Used: false }
  }
  const [filters, setFilters] = useState({
   certified: "", new: "", make: "", model: "", year: "", search: ""
  })
  const [criteria, setCriteria] = useState({
   certified: {}, new: {}, make: {}, model: {}, year: {}
  })
  const { allInventoryJson } = useStaticQuery(staticQuery)
  const allInventoryJsonClean = removeDups(allInventoryJson.nodes)
  const includeCertified = data.includeCertified
  
  // wn-224
  useEffect(() => {
    if (allInventoryJson && allInventoryJson.nodes) {
      const initialFilters = {...filters};
      // Check if the manufacturer should be used as the default make
      if (passedProp.useManufacturerHompageSearch && passedProp.manufacturer) {
        initialFilters.make = passedProp.manufacturer;
      }
  
      setFilters(initialFilters);
      const _criteria = countUnique(allInventoryJson.nodes);
      setCriteria(_criteria);
    }
  }, [passedProp, allInventoryJson ? allInventoryJson.nodes : null]);
  
  useEffect(() => {
    const _criteria = countUnique(allInventoryJson.nodes)
    setCriteria(_criteria)
  }, [allInventoryJson.nodes])

  const filtersMap = {
    "certified": (node, value) => node.VehicleInfo.IsCertified === value,
    "new": (node, value) => node.VehicleInfo.IsNew === value,
    "make": (node, value) => node.VehicleInfo.Make === value,
    "model": (node, value) => node.VehicleInfo.Model === value,
    "year": (node, value) => node.VehicleInfo.Year === Number(value),
  }

  function filterVehiclesByDealerID(vehicles, dealerID) {
    if (dealerID === "") {
      return vehicles;
    }
    const intDealerID = parseInt(dealerID, 10);
    const filteredVehicles = vehicles.filter(node => {
      if (node.VehicleInfo.DealerID === intDealerID) {
        const sortDealerName = node.VehicleInfo.DealerName;
        dealerNameNoSpace = sortDealerName.replace(/\s+/g, '');
        return true;
      }
      return false;
    });
    return filteredVehicles;
  }  

  function countUnique(vehicles) {
    vehicles = filterVehiclesByDealerID(vehicles, dealerID);
    const discardMap = {
      certified: {
        Certified: vehicles.filter(node => node.VehicleInfo.IsCertified === true && node.VehicleInfo.VehicleStatus !== "_hidden").length
      },
      new: {
        New: vehicles.filter(node => node.VehicleInfo.IsNew === true && node.VehicleInfo.VehicleStatus !== "_hidden").length,
        'Used & Certified': vehicles.filter(node => node.VehicleInfo.IsNew === false && node.VehicleInfo.VehicleStatus !== "_hidden").length,
      },
      model: {},
      make: {},
      year: {}
    }

    vehicles.forEach(node => {
      if (node.VehicleInfo.VehicleStatus != "_hidden") {
        //const newKey = node.VehicleInfo.IsNew ? "New" : "Used"        
        //if (discardMap["new"].hasOwnProperty(newKey)) {
        //  discardMap["new"][newKey]++
        //} else {
        //  discardMap["new"][newKey] = 1
        //}

        if (discardMap["year"].hasOwnProperty(node.VehicleInfo.Year)) {
          discardMap["year"][node.VehicleInfo.Year]++
        } else {
          discardMap["year"][node.VehicleInfo.Year] = 1
        }

        if (discardMap["model"].hasOwnProperty(node.VehicleInfo.Model)) {
          discardMap["model"][node.VehicleInfo.Model]++
        } else {
          discardMap["model"][node.VehicleInfo.Model] = 1
        }

        if (discardMap["make"].hasOwnProperty(node.VehicleInfo.Make)) {
          discardMap["make"][node.VehicleInfo.Make]++
        } else {
          discardMap["make"][node.VehicleInfo.Make] = 1
        }
      }
    })

    return discardMap
  }

  const dropValues = {
    New: allInventoryJsonClean.filter(node => node.VehicleInfo.IsNew === true && node.VehicleInfo.VehicleStatus !== "_hidden").length,
    'Used & Certified': allInventoryJsonClean.filter(node => node.VehicleInfo.IsNew === false && node.VehicleInfo.VehicleStatus !== "_hidden").length,
    Certified: allInventoryJsonClean.filter(node => node.VehicleInfo.IsCertified === true && node.VehicleInfo.VehicleStatus !== "_hidden").length
  }
  
  const dropValues2 = {
    New: allInventoryJsonClean.filter(node => node.VehicleInfo.IsNew === true && node.VehicleInfo.VehicleStatus !== "_hidden").length,
    Used: allInventoryJsonClean.filter(node => (node.VehicleInfo.IsNew === false) && (node.VehicleInfo.IsCertified === false) && node.VehicleInfo.VehicleStatus !== "_hidden").length,
    Certified: allInventoryJsonClean.filter(node => node.VehicleInfo.IsCertified === true && node.VehicleInfo.VehicleStatus !== "_hidden" ).length
  }

  function removeDups(vehicles) {
    vehicles = filterVehiclesByDealerID(vehicles, dealerID);
    let unique = {};
    vehicles.forEach((v) => {
      if(!unique[v.VehicleInfo.VIN]) {
        unique[v.VehicleInfo.VIN] = v;
      }
    });
    let finalVehicleInfo = []
    Object.keys(unique).map((item, i) => (
        finalVehicleInfo = finalVehicleInfo.concat(unique[item])
    ))
    return finalVehicleInfo;
  }

  function matchCriteria() {
    let matched = allInventoryJsonClean
    Object.keys(filters).forEach(type => {
      if (filters[type] !== undefined && String(filters[type]).length >= 1) {
        const array = matched
        matched = array.filter(node => filtersMap[type](node, filters[type]))
      }
    })

    return countUnique(matched)
  }

  const addFilter = ({ type, value }) => {
    if (value === 'Certified') {
      type = 'certified'
    }
    const _filters = filters
    _filters[type] = labelMap.hasOwnProperty(type) ? labelMap[type][value] : value
    setFilters({ ...filters, ..._filters })

    console.log(type, value)
    const _criteria = matchCriteria()
    if (value !== undefined && value.length >= 1) {
      delete _criteria[type]
    }
    setCriteria({ ...criteria, ..._criteria })
  }

  const buildSearchQuery = (dealerNameNoSpace) => {
    const queryFromFilters = Object.keys(filters).map(key => {
      if (filters[key] != undefined) {
        return String(filters[key]).length >= 1 ? escape(key) + '=' + escape(String(filters[key])) : null;
      }
    }).filter(element => element != null).join('&');
    const dealerQuery = dealerNameNoSpace && dealerNameNoSpace !== "" ? `dealer=${dealerNameNoSpace}` : "";
    return [queryFromFilters, dealerQuery].filter(Boolean).join('&');
  }
  

  const addSearchFilter = (event) => {
    const _filters = filters
    _filters.search = event.target.value
    setFilters({ ...filters, ..._filters })
  }

  // const keyPress = (e) => {
  //   if (e.keyCode == 13) {
  //     const query = `/search/?${buildSearchQuery(dealerNameNoSpace)}`
  //     window.open(query, "_self")
  //   }
  // }
  const keyPress = (e) => {
    if (e.keyCode === 13) {  
      const query = `/search/?${buildSearchQuery(dealerNameNoSpace)}`;
      navigate(query);  
    }
  };

  const renderSearch = () => (
    <div className={view["filter-nsect"]}>
      <label for="searchbox" style={{display: "none"}}>Search Vehicles</label>
      <input id="searchbox" placeholder={"Type here to search"}
        onChange={addSearchFilter} onKeyDown={keyPress} />
    </div>
  )

  return (
    <>
      {/* responsive filtering */}
      {/*<div className={`${grid["col-xs-6"]} ${grid["col-sm-3"]} ${grid["col-lg"]} 
        ${view["camper-filter"]}`}>
        <div className={`${view["camper-item"]}`}>
          <div className={view["camper-cont"]}>
            <p>SHOW FILTERS</p>
          </div>
          <div className={`${view["camper-dcont"]}`}>
            <p className={view["camper-desc"]}>
              SHOW ITEMS
            </p>
          </div>
        </div>
      </div>
      /*}

      {/* non-responsive filtering */}
      <div className={`${grid["col-xs-12"]} ${view["search-bar"]}`}
        style={{ backgroundColor: data.bgOverride && data.bgColor }}>
        <div className={`${view["filter-nresp"]}`}>
          <div className={`${grid["row"]} ${grid["col-lg-10"]} ${grid["col-md-12"]}`}>
            <div className={`${grid["col-lg"]} ${grid["col-sm-6"]} ${grid["col-xs-12"]}`}>
              {includeCertified ? <div className={view["filter-nsect"]}>
                <DropdownOption type="new" placeholder="NEW & USED"
                  values={dropValues} addFilter={addFilter} label={"Condition"} />
              </div> : <div className={view["filter-nsect"]}>
                <DropdownOption type="new" placeholder="NEW & USED"
                  values={dropValues2} addFilter={addFilter} label={"Condition"} />
              </div>}
            </div>
            <div className={`${grid["col-lg"]} ${grid["col-sm-6"]} ${grid["col-xs-12"]}`}>
              <div className={view["filter-nsect"]}>
                <DropdownOption type="year" placeholder="ALL YEARS"
                  values={criteria.year} addFilter={addFilter} label={"Year"}
                  sorter={(a, b) => (b - a)} />
              </div>
            </div>
            <div className={`${grid["col-lg"]} ${grid["col-sm-6"]} ${grid["col-xs-12"]}`}>
              <div className={view["filter-nsect"]}>
                <DropdownOption 
                  type="make" 
                  placeholder="All Makes"
                  values={criteria.make} 
                  addFilter={addFilter} 
                  label={"Makes"} 
                  selectedValue={filters.make}
                />
              </div>
            </div>
            <div className={`${grid["col-lg"]} ${grid["col-sm-6"]} ${grid["col-xs-12"]}`}>
              <div className={view["filter-nsect"]}>
                <DropdownOption type="model" placeholder="ALL MODELS"
                  values={criteria.model} addFilter={addFilter} label={"Models"}
                  sorter={(a, b) => {
                    return a.localeCompare(b);
                  }} />
              </div>
            </div>
            <div className={`${grid["col-lg"]} ${grid["col-sm-12"]} ${grid["col-xs-12"]}`}>
              {renderSearch()}
            </div>
          </div>
          <div className={`${grid["col-lg"]} ${grid["col-md-12"]} ${grid["col-xs-12"]}`}>
            <Link className={view["filter-nbutn"]}
              style={{ backgroundColor: data.btOverride && data.btColor }}
              to={"/search/?" + buildSearchQuery(dealerNameNoSpace)}>
              SEARCH
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

SearchBar.defaultProps = {
  data: {
    bgOverride: true,
    bgColor: "#000000",
    btOverride: false,
    btcolor: "#ffffff",
    order: 4,
    visible: true
  },
  mainDealerID: ""
} 
